import {
  ButtonIndicatorTokenByStringProps,
  Indicator,
} from 'common/masonry-types';

const ButtonIconTokenByString: ButtonIndicatorTokenByStringProps = {
  NEW_TAB_INTERNAL: 'newTabInternal',
  NEW_WINDOW_INTERNAL: 'newWindowInternal',
  EXTERNAL_LINK: 'externalLink',
};

export const getButtonIconToken = (indicatorString: Indicator) =>
  ButtonIconTokenByString[indicatorString!];
